// Auto-split from i18n.js — language: nl
export default {
    translation: {
        // routes & menus
        Dashboard: 'Dashboard',
        'Space Data': 'Ruimtegegevens',
        'Equipment Data': 'Apparatuurgegevens',
        'Meter Data': 'Meetgegevens',
        'Tenant Data': 'Huurdergegevens',
        'Store Data': 'Winkelgegevens',
        'Shopfloor Data': 'Werkvloergegevens',
        'Combined Equipment Data': 'Gecombineerde Apparatuurgegevens',
        'Auxiliary System': 'Hulpsysteem',
        Microgrid: 'Microgrid',
        'Energy Storage Power Station': 'Energieopslagcentrale',
        'Photovoltaic Power Station': 'Fotovoltaïsche centrale',
        'Fault Alarm': 'Foutalarm',
        Monitoring: 'Apparatuurmonitoring',
        'Advanced Reporting': 'Geavanceerde rapportage',
        'Knowledge Base': 'Kennisbank',
        'Energy Category Data': 'Energiecategorie-analyse',
        'Energy Item Data': 'Energieonderdeel-analyse',
        Carbon: 'CO2-uitstootanalyse',
        Cost: 'Kostenanalyse',
        Output: 'Outputanalyse',
        Income: 'Inkomstenanalyse',
        Efficiency: 'Efficiëntieanalyse',
        Load: 'Belastingsanalyse',
        Statistics: 'Statistische analyse',
        'Batch Analysis': 'Batchanalyse',
        Saving: 'EnergiebesparingsanalyseⒺ',
        Plan: 'PlanningsanalyseⒺ',
        Prediction: 'VoorspellingsanalyseⒺ',
        'Production': 'Productie',
        'Space Production': 'Productie-energieverbruiksanalyse',
        'Equipment Tracking': 'Apparatuurlogboek',
        'Equipment Comparison': 'Vergelijkende analyse',
        'Shopfloor Comparison': 'Vergelijkende analyse',
        'Store Comparison': 'Vergelijkende analyse',
        'Space Comparison': 'Vergelijkende analyse',
        'Combined Equipment Comparison': 'Vergelijkende analyse',
        'Tenant Comparison': 'Vergelijkende analyse',
        'Environment Monitor': 'Omgevingsmonitoring',
        'Meter Energy': 'Meetmeter energieverbruiksanalyse',
        'Meter Prediction': 'Meter VoorspellingsanalyseⒺ',
        'Virtual Meter Prediction': 'Virtuele Meter VoorspellingsanalyseⒺ',
        'Offline Meter Prediction': 'Offline Meter VoorspellingsanalyseⒺ',
        'Meter Carbon': 'Meetmeter CO2-uitstootanalyse',
        'Meter Cost': 'Meetmeter kostenanalyse',
        'Meter Trend': 'Meetmeter trendanalyse',
        'Meter Realtime': 'Meetmeter realtime-analyse',
        'Meter Saving': 'Meetmeter energiebesparingsanalyseⒺ',
        'Meter Plan': 'Meetmeter planningsanalyseⒺ',
        'Master Meter Submeters Balance': 'Hoofd-/submeters balansanalyse',
        'Meter Batch Analysis': 'Meetmeter batchanalyse',
        'Meter Comparison': 'Meetmeter vergelijkende analyse',
        'Meter Tracking': 'Meetmeter logboek',
        'Virtual Meter Saving': 'Virtuele meter energiebesparingsanalyseⒺ',
        'Virtual Meter Plan': 'Virtuele meter planningsanalyseⒺ',
        'Virtual Meter Energy': 'Virtuele meter energieverbruiksanalyse',
        'Virtual Meter Carbon': 'Virtuele meter CO2-uitstootanalyse',
        'Virtual Meter Cost': 'Virtuele meter kostenanalyse',
        'Virtual Meter Batch Analysis': 'Virtuele meter batchanalyse',
        'Virtual Meter Comparison': 'Virtuele meter vergelijkende analyse',
        'Offline Meter Energy': 'Offline meter energieverbruiksanalyse',
        'Offline Meter Carbon': 'Offline meter CO2-uitstootanalyse',
        'Offline Meter Cost': 'Offline meter kostenanalyse',
        'Offline Meter Batch Analysis': 'Offline meter batchanalyse',
        'Offline Meter Saving': 'Offline meter energiebesparingsanalyseⒺ',
        'Offline Meter Plan': 'Offline meter planningsanalyseⒺ',
        'Offline Meter Input': 'Offline meter gegevensinvoer',
        'Tenant Bill': 'Huurderrekening',
        'Energy Flow Diagram': 'Energieflowdiagram',
        'Distribution System': 'Distributiesysteem',
        'SVG System': 'Configuratie visualisatiesysteem',
        'Faults Data': 'Foutanalyse',
        'Space Equipments': 'Ruimteapparatuur',
        'Combined Equipments': 'Gecombineerde apparatuur',
        'Energy Storage Power Station List': 'Energieopslagcentrale lijst',
        'Energy Storage Power Station Details': 'Apparatuurmonitoring',
        'Energy Storage Power Station Reporting': 'Gegevensrapportage',
        'Energy Storage Power Station Alarm': 'Foutalarm',
        'Energy Storage Power Station Maintenance': 'Onderhoud',
        'Enter Production': 'Productie-invoer',
        'Multiple Microgrids': 'Meerdere microgrids',
        'Multiple Microgrids Dashboard': 'Meerdere microgrids dashboard',
        'Multiple Microgrids List': 'Microgrid lijst',
        'Single Microgrid': 'Enkele microgrid',
        'Single Microgrid Dashboard': 'Enkele microgrid dashboard',
        'Single Microgrid Details': 'Apparatuurgegevens',
        'Single Microgrid Fault Alarm': 'Foutmelding',
        'Microgrid Reports': 'Statistische rapportage',
        'Microgrid Reports Energy': 'Energierapport',
        'Microgrid Reports Revenue': 'Inkomstenrapport',
        'Microgrid Reports Parameters': 'Gegevensquery',
        'Multiple Energy Storage Power Stations': 'Meerdere energieopslagcentrales',
        'Multiple Energy Storage Power Stations Dashboard': 'Meerdere energieopslagcentrales dashboard',
        'Multiple Energy Storage Power Stations List': 'Energieopslagcentrale lijst',
        'Single Energy Storage Power Station': 'Enkele energieopslagcentrale',
        'Single Energy Storage Power Station Dashboard': 'Enkele energieopslagcentrale dashboard',
        'Single Energy Storage Power Station Details': 'Energieopslagapparatuurgegevens',
        'Single Energy Storage Power Station Fault Alarm': 'Energieopslag foutmelding',
        'Energy Storage Power Station Reports': 'Energieopslag statistische rapportage',
        'Energy Storage Power Station Reports Energy': 'Energieopslag energierapport',
        'Energy Storage Power Station Reports Revenue': 'Energieopslag inkomstenrapport',
        'Energy Storage Power Station Reports Parameters': 'Energieopslag gegevensquery',
        'Photovoltaic Power Station List': 'Fotovoltaïsche centrale lijst',
        'Photovoltaic Power Station Details': 'Apparatuurmonitoring',
        'Photovoltaic Power Station Reporting': 'Gegevensrapportage',
        'Photovoltaic Power Station Alarm': 'Foutalarm',
        'Photovoltaic Power Station Maintenance': 'Onderhoud',
        'Multiple Photovoltaic Power Stations': 'Meerdere fotovoltaïsche centrales',
        'Multiple Photovoltaic Power Stations Dashboard': 'Meerdere fotovoltaïsche centrales dashboard',
        'Multiple Photovoltaic Power Stations List': 'Fotovoltaïsche centrale lijst',
        'Single Photovoltaic Power Station': 'Enkele fotovoltaïsche centrale',
        'Single Photovoltaic Power Station Dashboard': 'Enkele fotovoltaïsche centrale dashboard',
        'Single Photovoltaic Power Station Details': 'Apparatuurgegevens',
        'Single Photovoltaic Power Station Fault Alarm': 'Foutmelding',
        'Photovoltaic Power Station Reports': 'Statistische rapportage',
        'Photovoltaic Power Station Reports Energy': 'Energierapport',
        'Photovoltaic Power Station Reports Revenue': 'Inkomstenrapport',
        'Photovoltaic Power Station Reports Parameters': 'Gegevensquery',
        'Work Order': 'Werkorderbeheer',
        'Work Order Installation': 'Installatierecord',
        'Work Order Repair': 'Reparatierecord',
        'Work Order Inspection': 'Inspectierecord',
        'Total Number of Work Orders': 'Totaal aantal werkorders',
        'Number of New Work Orders': 'Aantal nieuwe werkorders',
        'Number of Inprogress Work Orders': 'Aantal lopende werkorders',
        'Number of Done Work Orders': 'Aantal voltooide werkorders',
        'Fuel Indicator': 'Brandstofverbruik',
        'Charge Energy Indicator': 'Oplaadenergie',
        'Discharge Energy Indicator': 'Ontlaadenergie',
        'Charge Cost Indicator': 'Oplaadkosten',
        'Discharge Revenue Indicator': 'Ontlaadinkomsten',
        'HVAC': 'Airconditioning',
        'Fire Control': 'Brandbeveiliging',
        'Store Dashboard': 'Winkel Dashboard',
        'Comprehensive overview of store energy performance': 'Uitgebreid overzicht van winkel energieprestaties',
        'Total Stores': 'Totaal Aantal Winkels',
        'Total Area': 'Totale Oppervlakte',
        'Active Meters': 'Actieve Meters',
        'Active Alerts': 'Actieve Waarschuwingen',
        'Total Energy Consumption': 'Totaal Energieverbruik',
        'Carbon Emissions': 'Koolstofuitstoot',
        'Current Period': 'Huidige Periode',
        'Energy Consumption by Category': 'Energieverbruik per Categorie',
        'Cost Distribution by Category': 'Kostenverdeling per Categorie',
        'Monthly Energy & Cost Trends': 'Maandelijkse Energie- en Kostentrends',
        'Top 5 Energy Consuming Stores': 'Top 5 Energieverbruikende Winkels',
        'Energy Category Details': 'Details Energiecategorieën',
        'Store Performance Overview': 'Overzicht Winkel Prestaties',
        'YoY Change': 'Jaarlijkse Verandering',
        'Per m²': 'Per m²',
        'Usage Intensity': 'Gebruiksintensiteit',
        'Dashboard data loaded successfully': 'Dashboard gegevens succesvol geladen',
        'Failed to load dashboard data': 'Laden dashboard gegevens mislukt',
        'Store Name': 'Winkel Naam',
        'Store Area': 'Winkel Oppervlakte',
        'Energy Consumption': 'Energieverbruik',
        'Consumption': 'Verbruik',
        'last period': 'vorige periode',
        // Tenant Dashboard
        'Tenant Dashboard': 'Huurders Dashboard',
        'Comprehensive overview of tenant energy performance': 'Uitgebreid overzicht van energieprestaties van huurders',
        'Total Tenants': 'Totaal Aantal Huurders',
        'Tenant Performance Overview': 'Overzicht Huurdersprestaties',
        'Tenant Name': 'Naam Huurder',
        'Tenant Area': 'Oppervlakte Huurder',
        'Tenant Type': 'Type Huurder',
        // Equipment Dashboard
        'Equipment Dashboard': 'Apparatuur Dashboard',
        'Total Equipments': 'Totaal Apparatuur',
        'Equipment Performance Overview': 'Overzicht Apparatuurprestaties',
        'Equipment Name': 'Naam Apparatuur',
        'Equipment Type': 'Type Apparatuur',
        'Total Energy': 'Totale Energie',
        'Total Sensors': 'Totaal Sensoren',
        'Increment Rate': 'Groeipercentage',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Totaal aantal werkplaatsen',
        'Shopfloor Performance Overview': 'Overzicht werkplaatsprestaties',
        'Shopfloor Name': 'Naam werkplaats',
        'Shopfloor Area': 'Oppervlakte werkplaats',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Totaal Aantal Gecombineerde Apparatuur',
        'Combined Equipment Performance Overview': 'Overzicht Gecombineerde Apparatuurprestaties',
        'Combined Equipment Name': 'Naam Gecombineerde Apparatuur',
        'Associated Equipments': 'Gerelateerde Apparatuur',

        // Dashboard
        'Welcome to QiXuan': 'Welkom bij QiXuan',
        'An Industry Leading Energy Management System': 'Een toonaangevend energiebeheersysteem',
        "This Year's Consumption CATEGORY VALUE UNIT": 'Jaarverbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'Jaarkosten {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'Maandverbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": 'Maandopwekking {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Costs CATEGORY VALUE UNIT": 'Maandkosten {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': 'Verbruik zelfde periode vorig jaar {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year': 'Kosten zelfde periode vorig jaar {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} verbruik {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} kosten {{UNIT}}',
        // Entities
        Space: 'Ruimte',
        Equipment: 'Apparatuur',
        Meter: 'Meetmeter',
        'Offline Meter': 'Offline meter',
        'Virtual Meter': 'Virtuele meter',
        Tenant: 'Huurder',
        Store: 'Winkel',
        Shopfloor: 'Werkvloer',
        'Combined Equipment': 'Gecombineerde apparatuur',
        'Cost Center': 'Kostenplaats',
        Name: 'Naam',
        DisplayName: 'Weergavenaam',
        UserName: 'Gebruikersnaam',
        Description: 'Beschrijving',
        'Energy Category': 'Energiecategorie',
        'Child Spaces': 'Onderliggende ruimtes',
        'Associated Equipment': 'Gerelateerde apparatuur',
        //Energy Categories
        Electricity: 'Elektriciteit',
        Water: 'Kraanwater',
        'Natural Gas': 'Aardgas',
        // SidePanelModal
        Settings: 'Instellingen',
        'Set your own customized style': 'Stel uw eigen aangepaste stijl in',
        'Color Scheme': 'Kleurenschema',
        'Choose the perfect color mode for your app': 'Kies de perfecte kleurmodus voor uw app',
        Light: 'Licht',
        Dark: 'Donker',
        'RTL Mode': 'RTL-modus',
        'Switch your language direction': 'Verander uw taalrichting',
        'Fluid Layout': 'Vloeiende layout',
        'Toggle container layout system': 'Wissel containerlayout systeem',
        'Navigation Position': 'Navigatiepositie',
        'Vertical': 'Verticaal',
        'Top': 'Boven',
        'Combo': 'Combinatie',
        'Transparent': 'Transparant',
        'Inverted': 'Ingekeerd',
        'Card': 'Kaart',
        'Vibrant': 'Levendig',
        'Select a suitable navigation system for your web application': 'Selecteer een geschikt navigatiesysteem voor uw webapplicatie',
        'Vertical Nav': 'Verticale navigatie',
        'Top Nav': 'Bovenste navigatie',
        'Vertical Navbar Style': 'Verticale navigatiebalk stijl',
        'Switch between styles for your vertical navbar': 'Wissel tussen stijlen voor uw verticale navigatiebalk',
        Language: 'Taal',
        'Switch between languages': 'Wissel tussen talen',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Vindt u dit systeem leuk?',
        'Get QiXuan now': 'Download QiXuan nu',
        'PQ.About': 'Deze analyse omvat spanningsafwijking, spanningsonbalans, frequentieafwijking en stroomonbalans. Spanningsafwijking berekend als (U−Un)/Un×100%; frequentieafwijking als |f−fn|; driefasige onbalans als max(|Xi−Xavg|)/Xavg×100%, vereist tijdsynchronisatie van driefasige kanalen. Resultaten gebaseerd op tijdreeksen van geselecteerde meetmeters in rapportageperiode. Bij ontbrekende driefasige kanalen of niet-gesynchroniseerde tijdstempels worden onbalansindicatoren overgeslagen. Transiënte pieken of ontbrekende samples kunnen slechtste waarde vergroten; voor steady-state evaluatie wordt verwezen naar statistische indicatoren zoals compliantiepercentage en P95.',
        Purchase: 'Koop Enterprise Editie',
        ContactInfo: 'Contactinformatie',
        ProductWebsite: 'Productwebsite',
        CompanyWebsite: 'Bedrijfswebsite',
        SalesPhone: 'Verkooptelefoon',
        // Query Panels
        'Base Period Begins': 'Basisperiode start',
        'Base Period Ends': 'Basisperiode einde',
        'Comparison Types': 'Vergelijkingstypes',
        'Year-Over-Year': 'Jaar-op-jaar',
        'Month-On-Month': 'Maand-op-maand',
        'Free Comparison': 'Vrije vergelijking',
        'None Comparison': 'Geen vergelijking',
        'Reporting Period Begins': 'Rapportageperiode start',
        'Reporting Period Ends': 'Rapportageperiode einde',
        '(Optional)': '(Optioneel)',
        'Period Types': 'Tijdsschaal',
        Yearly: 'Jaar',
        Monthly: 'Maand',
        Weekly: 'Week',
        Daily: 'Dag',
        Hourly: 'Uur',
        Submit: 'Indienen',
        'Input Energy Category': 'Verbruikte energiecategorie',
        'Output Energy Category': 'Geproduceerde energiecategorie',
        'Fraction Parameter': 'Breukparameter',
        Search: 'Zoeken',
        //DateRangePicker
        sunday: 'Zo',
        monday: 'Ma',
        tuesday: 'Di',
        wednesday: 'Wo',
        thursday: 'Do',
        friday: 'Vr',
        saturday: 'Za',
        ok: 'OK',
        today: 'Vandaag',
        yesterday: 'Gisteren',
        hours: 'Uur',
        minutes: 'Minuut',
        seconds: 'Seconde',
        last7Days: 'Laatste 7 dagen',
        tomorrow: 'Morgen',
        dayAfterTomorrow: 'Overmorgen',
        next7Days: 'Volgende 7 dagen',
        'Select Date Range': 'Selecteer datumbereik',
        //Card Summaries and Line Charts
        'Base Period': 'Basisperiode',
        'Reporting Period': 'Rapportageperiode',
        'Per Unit Area': 'Waarde per eenheid oppervlakte',
        'Per Capita': 'Waarde per persoon',
        'Per Unit Production': 'Waarde per eenheid product',
        Baseline: 'Baseline waarde',
        Actual: 'Werkelijke waarde',
        'Baseline Value - Actual Value': 'Baseline waarde - Werkelijke waarde',
        'Average Load': 'Gemiddelde belasting',
        'Maximum Load': 'Maximale belasting',
        'Load Factor': 'Belastingsfactor',
        'Ratio of Average Load to Maximum Load': 'Verhouding gemiddelde belasting tot maximale belasting',
        'Carbon Dioxide Emissions by Energy Category': 'CO2-uitstoot aandeel per energiecategorie',
        'Costs by Energy Category': 'Kostenaandeel per energiecategorie',
        'Incomes by Energy Category': 'Inkomensaandeel per energiecategorie',
        'Electricity Consumption by Time-Of-Use': 'Elektriciteitsverbruik per tijd-van-dag',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'CO2-uitstoot elektriciteit per tijd-van-dag',
        'Electricity Cost by Time-Of-Use': 'Elektriciteitskosten per tijd-van-dag',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} verbruiksaandeel per energieonderdeel',
        'Ton of Standard Coal by Energy Category': 'Ton standaardkool (TCE) aandeel per energiecategorie',
        'Ton of Carbon Dioxide Emissions by Energy Category': 'Ton CO2-uitstoot (TCO2E) aandeel per energiecategorie',
        'Reporting Period Consumption CATEGORY UNIT': 'Rapportageperiode verbruik {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Rapportageperiode voorspelling {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': '{{EQUIPMENT}} rapportageperiode verbruik {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} rapportageperiode verbruik {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Rapportageperiode productie {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Basisperiode productie {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Rapportageperiode verbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Rapportageperiode voorspelling {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Basisperiode verbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Rapportageperiode voorspelling {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': 'Rapportageperiode verbruik {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': 'Rapportageperiode verbruik {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'Basisperiode verbruik {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'Onderliggende ruimte categorie aandeel {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Onderliggende ruimte totaal aandeel',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': 'Rapportageperiode CO2-uitstoot {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Rapportageperiode CO2-uitstoot {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': 'Basisperiode CO2-uitstoot {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Rapportageperiode kosten {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Rapportageperiode kosten {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Basisperiode kosten {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Rapportageperiode output {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} rapportageperiode output {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} rapportageperiode output {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'Rapportageperiode output {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Basisperiode output {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Rapportageperiode inkomsten {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Rapportageperiode inkomsten {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Basisperiode inkomsten {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Rapportageperiode totale inkomsten {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': 'Rapportageperiode cumulatieve efficiëntie {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': '{{EQUIPMENT}} rapportageperiode cumulatieve efficiëntie {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} rapportageperiode cumulatieve algehele efficiëntie {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} rapportageperiode cumulatieve algehele efficiëntie {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} basisperiode cumulatieve algehele efficiëntie {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Momentane efficiëntie {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} momentane efficiëntie {{UNIT}}',
        'Equipment Efficiency Indicator': 'Indicator voor energie-efficiëntie van apparatuur',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} momentane algehele efficiëntie {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': 'Rapportageperiode cumulatieve efficiëntie {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT': 'Rapportageperiode cumulatieve efficiëntie {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Basisperiode cumulatieve efficiëntie {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT': 'Basisperiode cumulatieve efficiëntie {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Basisperiode {{CATEGORY}} maximale belasting {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Rapportageperiode {{CATEGORY}} maximale belasting {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'Rapportageperiode {{CATEGORY}} gemiddelde belasting {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Rapportageperiode {{CATEGORY}} belastingsfactor',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Basisperiode {{CATEGORY}} gemiddelde belasting {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Rapportageperiode {{CATEGORY}} gemiddelde {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Rapportageperiode {{CATEGORY}} maximum {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Rapportageperiode {{CATEGORY}} minimum {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Rapportageperiode {{CATEGORY}} rekenkundig gemiddelde {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Rapportageperiode {{CATEGORY}} mediaan {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Rapportageperiode {{CATEGORY}} steekproef standaardafwijking {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Rapportageperiode {{CATEGORY}} steekproef variantie {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': 'Rapportageperiode besparing {{CATEGORY}} (baseline - werkelijk) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': 'Rapportageperiode reductie {{CATEGORY}} (baseline - werkelijk) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'Rapportageperiode besparing {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Basisperiode besparing {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT': 'Rapportageperiode hoofdmeter verbruik {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': 'Rapportageperiode hoofdmeter verbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT': 'Rapportageperiode submeters verbruik {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': 'Rapportageperiode submeters verbruik {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Rapportageperiode verschil {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Rapportageperiode verschilpercentage',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'Rapportageperiode verschil {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': 'Trendwaarden',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Foutenlijst',
        'Reporting Period Number of Fault VALUE': 'Rapportageperiode foutaantal: {{VALUE}}',
        'All Faults': 'Alle fouten',
        'Space Faults': 'Ruimtefouten',
        'Number of All Faults': 'Totaal foutaantal',
        'Number of Space Faults': 'Ruimte foutaantal',
        'Total Number of Faults': 'Totaal aantal fouten',
        'Number of New Faults': 'Aantal nieuwe fouten',
        'Number of Inprogress Faults': 'Aantal lopende fouten',
        'Number of Done Faults': 'Aantal voltooide fouten',
        //Data Panels
        'Ton of Standard Coal': 'Ton standaardkool',
        'Ton of Carbon Dioxide Emissions': 'Ton CO2-uitstoot',
        'Carbon Emissions Per Unit Of Energy Consumption': 'CO2-uitstoot per energieverbruikseenheid',
        'Operating Characteristic Curve': 'Bedrijfskenmerkcurve',
        Tariff: 'Tarief',
        'Detailed Data': 'Gedetailleerde gegevens',
        'Child Spaces Data': 'Onderliggende ruimtegegevens',
        'Associated Equipment Data': 'Gerelateerde apparatuurgegevens',
        'This Year': 'Dit jaar',
        'The Same Period Last Year': 'Zelfde periode vorig jaar',
        'This Month': 'Deze maand',
        'This Day': 'Vandaag',
        Total: 'Totaal',
        'No data found': 'Geen gegevens gevonden',
        Export: 'Exporteren',
        'AI Analysis': 'AI-analyse',
        Datetime: 'Datumtijd',
        'Time-Of-Use Type': 'Tijd-van-dag type',
        'Top-Peak': 'Piek',
        'On-Peak': 'Hoog',
        'Mid-Peak': 'Normaal',
        'Off-Peak': 'Dal',
        'Deep': 'Diep dal',
        Percentage: 'Percentage',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Trend laatste uur van energie waardepunt',
        Circuit: 'Circuit',
        Point: 'Datapunt',
        'Realtime Value': 'Realtime waarde',
        //Meter Tracking
        'Meter List': 'Meetmeter lijst',
        'Edit Meter': 'Bewerken',
        'Start Value': 'Startwaarde',
        'End Value': 'Eindwaarde',
        'Difference Value': 'Verschilwaarde',
        'Start Integrity Rate': 'Start gegevensintegriteit (%)',
        'End Integrity Rate': 'Eind gegevensintegriteit (%)',
        'Full Integrity Rate': 'Volledige gegevensintegriteit (%)',
        'Start Integrity Rate Description': 'Startgegevensintegriteitspercentage: Aandeel van alle meters dat tijdens de statistische periode met succes energieverbruiksmetingen heeft verkregen op het starttijdstip',
        'End Integrity Rate Description': 'Eindgegevensintegriteitspercentage: Aandeel van alle meters dat tijdens de statistische periode met succes energieverbruiksmetingen heeft verkregen op het eindtijdstip',
        'Full Integrity Rate Description': 'Volledige gegevensintegriteitspercentage: Aandeel van alle meters dat tijdens de statistische periode met succes energieverbruiksmetingen heeft verkregen op zowel het start- als eindtijdstip',
        //Equipment Tracking
        'Equipment List': 'Apparatuurlijst',
        'Edit Equipment': 'Bewerken',
        //Profile Dropdown
        Feedback: 'Feedback',
        'Account Settings': 'Accountinstellingen',
        Logout: 'Uitloggen',
        //Authentication
        'Log in': 'Inloggen',
        'Email address': 'E-mailadres',
        'Phone Number': 'Telefoonnummer',
        Password: 'Wachtwoord',
        CaptchaCode: 'Captcha',
        Refresh: 'Vernieuwen',
        'Remember me': 'Onthoud mij',
        'Logged in as ': 'Ingelogd als ',
        'Forgot Password?': 'Wachtwoord vergeten?',
        'Forgot your password?': 'Wachtwoord vergeten?',
        "Enter your email and we'll send you a reset link": 'Voer uw e-mailadres in en we sturen u een resetlink',
        "Enter your email and we'll send you a registration link": 'Voer uw e-mailadres in en we sturen u een registratielink',
        'Reset Password': 'Wachtwoord resetten',
        'Thanks for using QiXuan!': 'Bedankt voor het gebruiken van QiXuan!',
        'You are now successfully signed out': 'U bent succesvol uitgelogd',
        'Return to Login': 'Terug naar inloggen',
        'Please check your email!': 'Controleer uw e-mail!',
        'An email has been sent to ': 'Een e-mail is verzonden naar ',
        'Please click on the included link to reset your password': 'Klik op de bijgevoegde link om uw wachtwoord te resetten',
        'Please click on the included link to register your account': 'Klik op de bijgevoegde link om uw account te registreren',
        'An email with password reset link is sent to ': 'Een e-mail met wachtwoord resetlink is verzonden naar ',
        'Change Password': 'Wachtwoord wijzigen',
        'Old Password': 'Oud wachtwoord',
        'New Password': 'Nieuw wachtwoord',
        'Confirm Password': 'Herhaal nieuw wachtwoord',
        'Update Password': 'Wachtwoord bijwerken',
        'Password has been changed!': 'Wachtwoord is gewijzigd!',
        'Verification code has been sent to your inbox. \
        Please copy it to the input box below.':
            'Verificatiecode is naar uw inbox verzonden. Kopieer deze naar het onderstaande invoervak.',
        'New to QiXuan': 'Nieuw bij QiXuan',
        'Create an account': 'Account aanmaken',
        'EMAIL Account registration successful': '{{EMAIL}} accountregistratie succesvol',
        'Thanks for verifying your account!': 'Bedankt voor het verifiëren van uw account!',
        'Your code is': 'Uw code is',
        'Send verification code': 'Verificatiecode verzenden',
        'Please wait for NUMBER seconds': 'Wacht {{NUMBER}} seconden',
        'Password reset': 'Wachtwoord reset',
        'Please wait for approval': 'Wacht op goedkeuring',
        //notification
        Notifications: 'Notificaties',
        'Mark all as read': 'Alles als gelezen markeren',
        'View all': 'Alles bekijken',
        'Notification New': 'Nieuw',
        'Notification Earlier': 'Eerder',
        'Notification List': 'Notificatielijst',
        'Bulk actions': 'Bulkacties',
        'Notification Subject': 'Onderwerp',
        'Notification Created Datetime': 'Aanmaaktijd',
        'Notification Message': 'Inhoud',
        'Notification Priority': 'Prioriteit',
        'Notification Status': 'Status',
        'Notification Mark As Read': 'Markeren als gelezen',
        'Notification Mark As Acknowledged': 'Bevestigen',
        'Notification Low': 'Laag',
        'Notification Medium': 'Gemiddeld',
        'Notification High': 'Hoog',
        'Notification Critical': 'Kritiek',
        'Notification Unread': 'Ongelezen',
        'Notification Read': 'Gelezen',
        'Notification Acknowledged': 'Bevestigd',
        'Notification Archive': 'Archiveren',
        'Notification Delete': 'Verwijderen',
        'Notification Apply': 'Toepassen',
        'Notification Start Datetime': 'Starttijd',
        'Notification End Datetime': 'Eindtijd',
        'Notification Update Datetime': 'Bijwerkingstijd',
        //Monitoring
        'Run Commands': 'Opdrachten uitvoeren',
        'Pin Code': 'Pincode',
        'Unlock': 'Ontgrendelen',
        'Set Value': 'Waarde instellen',
        'Fault Alarms': 'Foutalarmen',
        'Instantaneous Efficiency VALUE UNIT': 'Momentane efficiëntie {{VALUE}} {{UNIT}}',
        'Communication Status': 'Communicatiestatus',
        'Communication Online': 'Online',
        'Communication Offline': 'Offline',
        'Equipment Status': 'Apparatuurstatus',
        'Equipment Running': 'Actief',
        'Equipment Stopped': 'Gestopt',
        'Show Up to': 'Aantal per pagina',
        All: 'Alle',
        'FROM - TO of TOTAL': 'Momenteel getoond {{FROM}} - {{TO}} Totaal {{TOTAL}}',
        //Microgrid
        'Microgrid Energy': 'Energie',
        'Microgrid Revenue': 'Inkomsten',
        'Microgrid Carbon': 'CO2-uitstoot',
        'Photovoltaic Generation': 'Fotovoltaïsche opwekking',
        'EV Charger Consumption': 'EV-laadpaal verbruik',
        'Load Consumption': 'Belasting verbruik',
        'Grid Buy': 'Energie kopen van net',
        'Grid Sell': 'Energie verkopen aan net',
        'EV Charger': 'EV-laadpaal',
        'Heat Pump': 'Warmtepomp',
        'Photovoltaic': 'Fotovoltaïsch',
        'PCS Run State': 'PCS bedrijfsstatus',
        'PCS Unknown': 'Onbekend',
        'PCS Initializing': 'Initialiseren',
        'PCS Standby': 'Stand-by',
        'PCS Shutdown': 'Uitgeschakeld',
        'PCS Fault': 'Fout',
        'PCS Running': 'Actief',
        'Battery Power': 'Batterijvermogen',
        'Photovoltaic Power': 'Fotovoltaïsch vermogen',
        'Grid Power': 'Netvermogen',
        'Load Power': 'Belastingsvermogen',
        Reporting: 'Gegevensrapportage',
        Maintenance: 'Onderhoud',
        'General Information': 'Algemene informatie',
        'Serial Number': 'Serienummer',
        Address: 'Adres',
        'Postal Code': 'Postcode',
        'Rated Capacity': 'Nominale capaciteit',
        'Rated Power': 'Nominaal vermogen',
        Latitude: 'Breedtegraad',
        Longitude: 'Lengtegraad',
        'Strategy Management': 'Strategiebeheer',
        'Charging Schedule': 'Oplaadschema',
        'Charge Start Time': 'Oplaad starttijd',
        'Charge End Time': 'Oplaad eindtijd',
        'Discharge Start Time': 'Ontlaad starttijd',
        'Discharge End Time': 'Ontlaad eindtijd',
        'Total Rated Power': 'Totaal nominaal vermogen',
        'Total Rated Capacity': 'Totaal nominale capaciteit',
        // Energy Indicator
        "Today's Charge": "Vandaag opgeladen",
        "Today's Discharge": "Vandaag ontladen",
        "Today's Generation": "Vandaag opgewekt",
        'Total Fuel Consumption': 'Totaal brandstofverbruik',
        'Total Charge': 'Totaal opgeladen',
        'Total Discharge': 'Totaal ontladen',
        'Total Generation': 'Totaal opgewekt',
        'Total Revenue': 'Totale inkomsten',
        'Total Photovoltaic Generation': 'Totaal fotovoltaïsch opgewekt',
        'Total EV Charger Consumption': 'EV-laadpaal totaal verbruik',
        'Total Load Consumption': 'Belasting totaal verbruik',
        'Total Grid Buy': 'Totaal gekocht van net',
        'Total Grid Sell': 'Totaal verkocht aan net',
        'Total Efficiency': 'Totale efficiëntie',
        'Discharge Achievement Rate': 'Ontlaadrealisatiepercentage',
        // Revenue Indicator
        "Today's Cost": "Kosten vandaag",
        "Today's Income": "Inkomsten vandaag",
        "Total Cost": "Totale kosten",
        "Total Income": "Totale inkomsten",
        "Today's Revenue": "Winst vandaag",

        'Revenue Ranking': 'Inkomstenranglijst',
        'Efficiency Ranking': 'Efficiëntieranglijst',
        'Charge Ranking': 'Oplaadranglijst',
        'Discharge Ranking': 'Ontlaadranglijst',
        'Number of Microgrids': 'Aantal microgrids',
        'Number of Power Stations': 'Aantal centrales',
        'Microgrid List': 'Microgrid lijst',
        'Select Microgrid': 'Selecteer microgrid',
        'Previous Page': 'Vorige pagina',
        'Next Page': 'Volgende pagina',
        '7 Days': '7 dagen',
        'Charge UNIT': 'Oplaad {{UNIT}}',
        'Discharge UNIT': 'Ontlaad {{UNIT}}',
        'Generation UNIT': 'Opwekking {{UNIT}}',
        'Energy Indicator': 'Energie',
        'Revenue Indicator': 'Inkomsten',
        'Carbon Indicator': 'CO2',

        // Energy Storage Power Station
        'Battery Operating State': 'Batterij bedrijfsstatus',
        'Battery State': 'Batterijstatus',
        'Battery Unknown': 'Onbekend',
        'Battery Stopped': 'Gestopt',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': 'Fout', // 1
        'Battery Warning': 'Waarschuwing', // 2
        'Battery Standby': 'Stand-by', // 3
        'Battery Prohibit DisCharging': 'Ontladen verboden', // 4
        'Battery Prohibit Charging': 'Opladen verboden', // 5
        'Battery Normal': 'Normaal', // 6
        'Battery Charging': 'Opladen', // 7
        'Battery Discharging': 'Ontladen', // 8
        'Battery Idle': 'Inactief', // 9
        'Phase of Lifecycle': 'Levenscyclusfase',
        'Use Phase': 'In gebruik',
        'Commissioning Phase': 'Inbedrijfstelling',
        'Commissioning Date': 'Ingebruikname datum',
        'Installation Phase': 'In aanbouw',
        'Device Status': 'Apparaatstatus',
        'Basic Information': 'Basisinformatie',
        'Gateway': 'Gateway',
        'Grid Meter': 'Netmeetmeter',
        'Load Meter': 'Belastingmeetmeter',
        'ESS Meter': 'Energieopslagmeetmeter',
        'Total Active Power': 'Totaal actief vermogen',
        'Active Power A': 'Fase A actief vermogen',
        'Active Power B': 'Fase B actief vermogen',
        'Active Power C': 'Fase C actief vermogen',
        'Total Reactive Power': 'Totaal reactief vermogen',
        'Reactive Power A': 'Fase A reactief vermogen',
        'Reactive Power B': 'Fase B reactief vermogen',
        'Reactive Power C': 'Fase C reactief vermogen',
        'Total Apparent Power': 'Totaal schijnbaar vermogen',
        'Apparent Power A': 'Fase A schijnbaar vermogen',
        'Apparent Power B': 'Fase B schijnbaar vermogen',
        'Apparent Power C': 'Fase C schijnbaar vermogen',
        'Total Power Factor': 'Totale arbeidsfactor',
        'Active Energy Import': 'Actieve energie import',
        'Active Energy Export': 'Actieve energie export',
        'Active Energy Net': 'Netto actieve energie',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'Omvormer',
        'Invertor Run State': 'Omvormer bedrijfsstatus',
        'Invertor Unknown': 'Onbekend',
        'Invertor Initializing': 'Initialiseren',
        'Invertor Standby': 'Stand-by',
        'Invertor Shutdown': 'Uitgeschakeld',
        'Invertor Fault': 'Fout',
        'Invertor Running': 'Actief',

        //Advanced Reporting & Knowledge Base
        'Created Datetime': 'Aanmaaktijd',
        'File Format': 'Bestandsformaat',
        'File Size': 'Bestandsgrootte',
        Uploader: 'Uploader',
        'Upload Datetime': 'Uploadtijd',
        //Error
        "The page you're looking for is not found": 'De pagina die u zoekt bestaat niet',
        "Make sure the address is correct and that the page hasn't moved": 'Controleer of het adres correct is en de pagina niet verplaatst is',
        'If you think this is a mistake,': 'Als u denkt dat dit een fout is,',
        'contact us': 'neem contact met ons op',
        'Take me home': 'Terug naar startpagina',
        'Whoops, something went wrong!': 'Oeps, er is iets misgegaan!',
        'Try refreshing the page, or going back and attempting the action again':
            'Probeer de pagina te vernieuwen, of ga terug en probeer de actie opnieuw',
        'If this problem persists,': 'Als dit probleem aanhoudt,',
        'Captcha Error': 'Captcha fout',
        'Confirm Password Error': 'Wachtwoorden komen niet overeen',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'Het lijkt erop dat u op een ongeldige wachtwoord resetlink heeft geklikt. Probeer het opnieuw.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'Het lijkt erop dat u op een ongeldige accountregistratielink heeft geklikt. Probeer het opnieuw.',
        //Tenant Bill
        'Lease Contract Number': 'Huurcontractnummer',
        Download: 'Downloaden',
        Print: 'Afdrukken',
        'Payment Notice': 'Betalingsnotificatie',
        'Bill To': 'Aan',
        'Bill Number': 'Rekeningnummer',
        'Bill Date': 'Rekeningdatum',
        'Payment Due Date': 'Vervaldatum betaling',
        'Amount Payable': 'Te betalen bedrag',
        'Billing Period Start': 'Factureringsperiode start',
        'Billing Period End': 'Factureringsperiode einde',
        Quantity: 'Hoeveelheid',
        Price: 'Prijs',
        Unit: 'Eenheid',
        Amount: 'Bedrag',
        Subtotal: 'Subtotaal',
        'VAT Output Tax': 'BTW afdracht',
        'Total Amount Payable': 'Totaal te betalen bedrag',
        'Please make sure to pay on or before the payment due date above': 'Zorg ervoor dat u betaalt op of vóór bovenstaande vervaldatum',
        'Send money to the following account': 'Stort geld op de volgende rekening',
        'Account Name': 'Rekeninghouder',
        'Bank Name': 'Banknaam',
        'Bank Address': 'Bankadres',
        'RMB Account': 'RMB rekening',
        // button
        'Toggle Navigation': 'Navigatie in-/uitschakelen',
        // working calendar
        'Working Days': 'Werkdagen',
        'Non Working Days': 'Niet-werkdagen',
        'Select Row': 'Selecteer een rij om te bewerken',
        // Offline Meter Input
        'Daily Value': 'Dagelijkse waarde',
        Date: 'Datum',
        'Successfully Saved': 'Succesvol opgeslagen',
        'Previous Data Is Empty': 'Vorige gegevens zijn leeg',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account ontgrendelen mislukt',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Beheerderssessie bestaat niet',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Beheerderssessie is verlopen',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Geavanceerd rapport bestaat niet',
        'API.API_KEY_HAS_EXPIRED': 'Key is verlopen',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key naam is al in gebruik',
        'API.API_KEY_NOT_FOUND': 'Key niet gevonden',
        'API.BAD_REQUEST': 'Ongeldig verzoek',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balanceringsprijspunt niet gevonden',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Batterijstatuspunt niet gevonden',
        'API.BUY_METER_NOT_FOUND': 'Koopmeter niet gevonden',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Kan bestaande submeterniet instellen als hoofdmeter',
        'API.CHARGE_METER_NOT_FOUND': 'Oplaadmeter niet gevonden',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Gecombineerde apparatuur opdrachtsrelatie bestaat',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Gecombineerde apparatuur opdrachtsrelatie niet gevonden',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Relatie gecombineerde apparatuur en apparaat bestaat al',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Relatie gecombineerde apparatuur en apparaat bestaat niet',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Relatie gecombineerde apparatuur en meetmeter bestaat al',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relatie gecombineerde apparatuur en meetmeter bestaat niet',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Naam gecombineerde apparatuur is al in gebruik',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Gecombineerde apparatuur bestaat niet',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relatie gecombineerde apparatuur en offline meter bestaat al',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie gecombineerde apparatuur en offline meter bestaat niet',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Parameter naam gerelateerd aan gecombineerde apparatuur is al in gebruik',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parameter gerelateerd aan gecombineerde apparatuur bestaat niet of komt niet overeen',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relatie gecombineerde apparatuur en virtuele meter bestaat al',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie gecombineerde apparatuur en virtuele meter bestaat niet',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Opdrachtnaam is al in gebruik',
        'API.COMMAND_NOT_FOUND': 'Opdracht niet gevonden',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contactpersoon naam is al in gebruik',
        'API.CONTACT_NOT_FOUND': 'Contactpersoon bestaat niet',
        'API.COOLING_METER_NOT_FOUND': 'Koelmeter niet gevonden',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Kostenplaats externe ID bestaat al',
        'API.COST_CENTER_NAME_EXISTS': 'Kostenplaats naam bestaat al',
        'API.COST_CENTER_NOT_FOUND': 'Kostenplaats bestaat niet',
        'API.COST_FILE_NOT_FOUND': 'Kostenbestand bestaat niet',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data reparatiebestand niet gevonden',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Gegevensbron naam is al in gebruik',
        'API.DATA_SOURCE_NOT_FOUND': 'Gegevensbron bestaat niet',
        'API.DATABASE_ERROR': 'Databasefout',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Datum staat al in werkagenda',
        'API.DATE_LOCAL_NOT_FOUND': 'Lokale datum niet gevonden',
        'API.DISCHARGE_METER_NOT_FOUND': 'Ontlaadmeter niet gevonden',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distributiecircuit naam is al in gebruik',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distributiecircuit bestaat niet',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Relatie distributiecircuit en datapunt bestaat al',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Relatie distributiecircuit en datapunt bestaat niet',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distributiesysteem naam is al in gebruik',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distributiesysteem bestaat niet',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Elektriciteitsmeter niet gevonden',
        'API.EMAIL_IS_ALREADY_IN_USE': 'E-mailadres is al in gebruik',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'E-mailbericht bestaat niet',
        'API.EMAIL_NOT_FOUND': 'E-mailadres bestaat niet',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'E-mailserver host is al in gebruik',
        'API.EMAIL_SERVER_NOT_FOUND': 'E-mailserver host bestaat niet',
        'API.EMPTY_VARIABLES_ARRAY': 'Lege variabelen array',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energiecategorie naam is al in gebruik',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Energiecategorie bestaat niet',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energiecategorie wordt al gebruikt in energieonderdelen',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Energiecategorie wordt al gebruikt in meetmeter',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energiecategorie wordt al gebruikt in offline meter',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energiecategorie wordt al gebruikt in tarieven',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energiecategorie wordt al gebruikt in virtuele meter',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energieflowdiagram link is al in gebruik',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energieflowdiagram link bestaat niet of komt niet overeen',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energieflowdiagram naam is al in gebruik',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energieflowdiagram knooppunt is al in gebruik',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energieflowdiagram knooppunt bestaat niet of komt niet overeen',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energieflowdiagram bestaat niet',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energieonderdeel behoort niet tot energiecategorie',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energieonderdeel behoort niet tot energiecategorie',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energieonderdeel is al in gebruik',
        'API.ENERGY_ITEM_NOT_FOUND': 'Energieonderdeel bestaat niet',
        'API.ENERGY_ITEM_USED_IN_METER': 'Energieonderdeel wordt al gebruikt in meetmeter',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energieonderdeel wordt al gebruikt in offline meter',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energieonderdeel wordt al gebruikt in virtuele meter',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energieopslagcentrale naam is al in gebruik',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energieopslagcentrale niet gevonden',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Apparatuur opdrachtsrelatie bestaat',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Apparatuur opdrachtsrelatie niet gevonden',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Relatie apparatuur en meetmeter bestaat al',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relatie apparatuur en meetmeter bestaat niet',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Apparatuurnaam is al in gebruik',
        'API.EQUIPMENT_NOT_FOUND': 'Apparatuur bestaat niet',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relatie apparatuur en offline meter bestaat al',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie apparatuur en offline meter bestaat niet',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Parameter naam gerelateerd aan apparaat is al in gebruik',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parameter gerelateerd aan apparaat bestaat niet of komt niet overeen',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relatie apparatuur en virtuele meter bestaat al',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie apparatuur en virtuele meter bestaat niet',
        'API.ERROR': 'Fout',
        'API.EXCEPTION': 'Uitzondering',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Lezen verzoekstroom mislukt',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Herstellen kostenbestand mislukt',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Herstellen data reparatiebestand mislukt',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Herstellen kennisbestand mislukt',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Herstellen offline meterbestand mislukt',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Opslaan offline meterbestand mislukt',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Uploaden bijlagebestand mislukt',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Uploaden kostenbestand mislukt',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Uploaden data reparatiebestand mislukt',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Uploaden kennisbestand mislukt',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Uploaden offline meterbestand mislukt',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway naam is al in gebruik',
        'API.GATEWAY_NOT_FOUND': 'Gateway bestaat niet',
        'API.HEAT_METER_NOT_FOUND': 'Warmtemeter niet gevonden',
        'API.INVALID_': 'Ongeldig ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Ongeldige bevestigingscode',
        'API.INVALID_ADDRESS': 'Ongeldig adres',
        'API.INVALID_ADDRESS_VALUE': 'Ongeldige adreswaarde',
        'API.INVALID_ADVANCED_REPORT_ID': 'Ongeldig geavanceerd rapport ID',
        'API.INVALID_API_KEY_ID': 'Ongeldig API key ID',
        'API.INVALID_API_KEY_NAME': 'Ongeldige API key naam',
        'API.INVALID_AREA_VALUE': 'Ongeldige oppervlaktewaarde',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Ongeldig balanceringsprijspunt ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Ongeldige basisperiode eindtijd',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Ongeldige basisperiode starttijd',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Ongeldig batterijstatuspunt ID',
        'API.INVALID_BAUD_RATE': 'Ongeldige baudrate',
        'API.INVALID_BUILDINGS_VALUE': 'Ongeldige gebouwwaarde',
        'API.INVALID_BUY_METER_ID': 'Ongeldig koopmeter ID',
        'API.INVALID_CAPACITY': 'Ongeldige capaciteit',
        'API.INVALID_CATEGORY': 'Ongeldige categorie',
        'API.INVALID_CHANNEL': 'Ongeldig kanaal',
        'API.INVALID_CHARGE_METER_ID': 'Ongeldig oplaadmeter ID',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Ongeldig gecombineerd apparaat ID',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Ongeldige gecombineerde apparatuurnaam',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Ongeldig gecombineerd apparaat parameter ID',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Ongeldige gecombineerde apparaat parameternaam',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Ongeldig gecombineerd apparaat parametertype',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Ongeldige gecombineerde apparaat UUIDs',
        'API.INVALID_COMMAND_ID': 'Ongeldig opdracht ID',
        'API.INVALID_COMMAND_NAME': 'Ongeldige opdrachtnaam',
        'API.INVALID_CONNECTION': 'Ongeldige verbinding',
        'API.INVALID_CONSTANT_VALUE': 'Ongeldige constante waarde',
        'API.INVALID_CONTACT_ID': 'Ongeldig contactpersoon ID',
        'API.INVALID_CONTACT_NAME': 'Ongeldige contactpersoon naam',
        'API.INVALID_COOLING_METER_ID': 'Ongeldig koelmeter ID',
        'API.INVALID_COST_CENTER_ID': 'Ongeldig kostenplaats ID',
        'API.INVALID_COST_FILE_ID': 'Ongeldig kostenbestand ID',
        'API.INVALID_CREATED_DATETIME': 'Ongeldige aanmaaktijd',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Ongeldig data reparatiebestand ID',
        'API.INVALID_DATA_SOURCE_ID': 'Ongeldig gegevensbron ID',
        'API.INVALID_DATA_SOURCE_NAME': 'Ongeldige gegevensbron naam',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Ongeldig gegevensbron protocol',
        'API.INVALID_DATE_LOCAL': 'Ongeldige lokale datum',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Ongeldige standaard meetmeter UUID',
        'API.INVALID_DISCHARGE_METER_ID': 'Ongeldig ontlaadmeter ID',
        'API.INVALID_DISPLAY_NAME': 'Ongeldige weergavenaam',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Ongeldig distributiecircuit ID',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Ongeldige distributiecircuit naam',
        'API.INVALID_DISTRIBUTION_ROOM': 'Ongeldige verdeelkast',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Ongeldig distributiesysteem ID',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Ongeldige distributiesysteem naam',
        'API.INVALID_ELECTRICITY_METER_ID': 'Ongeldig elektriciteitsmeter ID',
        'API.INVALID_EMAIL': 'Ongeldig e-mailadres',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Ongeldig e-mailbericht ID',
        'API.INVALID_EMAIL_SERVER_HOST': 'Ongeldige e-mailserver host',
        'API.INVALID_EMAIL_SERVER_ID': 'Ongeldig e-mailserver ID',
        'API.INVALID_END_DATE_FORMAT': 'Ongeldig einddatumformaat',
        'API.INVALID_END_DATETIME': 'Ongeldige eindtijd',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Ongeldig energiecategorie ID',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Ongeldige energiecategorie naam',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Ongeldig energieflowdiagram ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Ongeldig energieflowdiagram link ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Ongeldige energieflowdiagram naam',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Ongeldig energieflowdiagram knooppunt ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Ongeldige energieflowdiagram knooppuntnaam',
        'API.INVALID_ENERGY_ITEM_ID': 'Ongeldig energieonderdeel ID',
        'API.INVALID_ENERGY_ITEM_NAME': 'Ongeldige energieonderdeel naam',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Ongeldig energieopslagcentrale ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Ongeldige energieopslagcentrale naam',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Ongeldige vergelijking in expressie',
        'API.INVALID_EQUIPMENT_ID': 'Ongeldig apparaat ID',
        'API.INVALID_EQUIPMENT_NAME': 'Ongeldige apparatuurnaam',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Ongeldig apparaat parameter ID',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Ongeldige apparaat parameternaam',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Ongeldig apparaat parametertype',
        'API.INVALID_EQUIPMENT_UUID': 'Ongeldige apparaat UUID',
        'API.INVALID_EXPIRES_DATETIME': 'Ongeldige vervaltijd',
        'API.INVALID_EXPRESSION': 'Ongeldige expressie',
        'API.INVALID_EXPRESSION_OBJECT': 'Ongeldig expressieobject',
        'API.INVALID_FDD_CODE': 'Ongeldige foutcode',
        'API.INVALID_FLOORS_VALUE': 'Ongeldige verdiepingwaarde',
        'API.INVALID_FROM_ADDR': 'Ongeldig adres',
        'API.INVALID_GATEWAY_ID': 'Ongeldig gateway ID',
        'API.INVALID_GATEWAY_NAME': 'Ongeldige gateway naam',
        'API.INVALID_HEAT_METER_ID': 'Ongeldig warmtemeter ID',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Ongeldige bovengrens waarde',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Ongeldige uurlijkse bovengrens waarde',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Ongeldige uurlijkse ondergrens waarde',
        'API.INVALID_Id': 'Ongeldig ID',
        'API.INVALID_IS_ADMIN_VALUE': 'Ongeldige beheerwaarde',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Ongeldig tonen kostengegevens',
        'API.INVALID_IS_COUNTED_VALUE': 'Ongeldige telwaarde',
        'API.INVALID_IS_ENABLED': 'Ongeldig ingeschakeld',
        'API.INVALID_IS_HIDDEN': 'Ongeldig verborgen',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Ongeldige inhuurwaarde',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Ongeldige invoer telwaarde',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Ongeldige hoofdhurderwaarde',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Ongeldige uitvoer telwaarde',
        'API.INVALID_IS_OUTPUT_VALUE': 'Ongeldige uitvoerwaarde',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Ongeldige alleen-lezen waarde',
        'API.INVALID_IS_TREND_VALUE': 'Ongeldige trendwaarde',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Ongeldige virtuele puntwaarde',
        'API.INVALID_KGCE': 'Ongeldige kilogram standaardkool coëfficiënt',
        'API.INVALID_KGCO2E': 'Ongeldige kilogram CO2-uitstoot coëfficiënt',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Ongeldig kennisbestand ID',
        'API.INVALID_LATITUDE_VALUE': 'Ongeldige breedtegraadwaarde',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Ongeldig huurcontractnummer',
        'API.INVALID_LONGITUDE_VALUE': 'Ongeldige lengtegraadwaarde',
        'API.INVALID_LOW_LIMIT_VALUE': 'Ongeldige ondergrens waarde',
        'API.INVALID_MASTER_METER_ID': 'Ongeldig hoofdmeter ID',
        'API.INVALID_MENU_ID': 'Ongeldig menu ID',
        'API.INVALID_MESSAGE_DATA': 'Ongeldige berichtgegevens',
        'API.INVALID_MESSAGE_TEMPLATE': 'Ongeldig berichtsjabloon',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Ongeldig berichtsjabloon ID',
        'API.INVALID_MESSAGE_VALUE': 'Ongeldige berichtwaarde',
        'API.INVALID_METER_ID': 'Ongeldig meetmeter ID',
        'API.INVALID_METER_NAME': 'Ongeldige meetmeternaam',
        'API.INVALID_METER_UUID': 'Ongeldige meetmeter UUID',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Ongeldig microgrid batterij ID',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Ongeldige microgrid batterij naam',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Ongeldig microgrid EV-laadpaal ID',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Ongeldige microgrid EV-laadpaal naam',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Ongeldig microgrid generator ID',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Ongeldige microgrid generator naam',
        'API.INVALID_MICROGRID_GRID_ID': 'Ongeldig microgrid net ID',
        'API.INVALID_MICROGRID_GRID_NAME': 'Ongeldige microgrid net naam',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Ongeldig microgrid warmtepomp ID',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Ongeldige microgrid warmtepomp naam',
        'API.INVALID_MICROGRID_ID': 'Ongeldig microgrid ID',
        'API.INVALID_MICROGRID_LOAD_ID': 'Ongeldig microgrid belasting ID',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Ongeldige microgrid belasting naam',
        'API.INVALID_MICROGRID_NAME': 'Ongeldige microgrid naam',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Ongeldig microgrid fotovoltaïsch ID',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Ongeldige microgrid fotovoltaïsch naam',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Ongeldig microgrid vermogensomzettingssysteem ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Ongeldige microgrid vermogensomzettingssysteem naam',
        'API.INVALID_MICROGRID_UUID': 'Ongeldige microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Ongeldige naamwaarde',
        'API.INVALID_NEW_PASSWORD': 'Ongeldig nieuw wachtwoord',
        'API.INVALID_NON_WORKING_DAY_ID': 'Ongeldig niet-werkdag ID',
        'API.INVALID_NOTIFICATION_ID': 'Ongeldig notificatie ID',
        'API.INVALID_NUMERATOR_METER_UUID': 'Ongeldige teller meter UUID',
        'API.INVALID_OBJECT_TYPE': 'Ongeldig objecttype',
        'API.INVALID_OFFLINE_METER_DATA': 'Ongeldige offline meter gegevens',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Ongeldig offline meterbestand ID',
        'API.INVALID_OFFLINE_METER_ID': 'Ongeldig offline meter ID',
        'API.INVALID_OFFLINE_METER_NAME': 'Ongeldige offline meternaam',
        'API.INVALID_OFFLINE_METER_UUID': 'Ongeldige offline meter UUID',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Ongeldige offset constante',
        'API.INVALID_OLD_PASSWORD': 'Ongeldig oud wachtwoord',
        'API.INVALID_OPENID': 'Ongeldige OpenID',
        'API.INVALID_PARENT_SPACE_ID': 'Ongeldig bovenliggende ruimte ID',
        'API.INVALID_PASSWORD': 'Ongeldig wachtwoord',
        'API.INVALID_PAYLOAD': 'Ongeldige payload',
        'API.INVALID_PEAK_CURRENT': 'Ongeldige piekstroom',
        'API.INVALID_PEAK_LOAD': 'Ongeldige piekbelasting',
        'API.INVALID_PERIOD_TYPE': 'Ongeldig periode type',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Ongeldig fotovoltaïsche centrale ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Ongeldige fotovoltaïsche centrale naam',
        'API.INVALID_POINT_ID': 'Ongeldig datapunt ID',
        'API.INVALID_POINT_NAME': 'Ongeldige datapuntnaam',
        'API.INVALID_PORT': 'Ongeldige poort',
        'API.INVALID_POSTAL_CODE_VALUE': 'Ongeldige postcodewaarde',
        'API.INVALID_POWER_POINT_ID': 'Ongeldig vermogenspunt ID',
        'API.INVALID_PRIORITY': 'Ongeldige prioriteit',
        'API.INVALID_PRIVILEGE': 'Ongeldig privilege',
        'API.INVALID_PRIVILEGE_DATA': 'Ongeldige privilegengegevens',
        'API.INVALID_PRIVILEGE_ID': 'Ongeldig privilege ID',
        'API.INVALID_PRIVILEGE_NAME': 'Ongeldige privilegenaam',
        'API.INVALID_RATIO_VALUE': 'Ongeldige verhoudingswaarde',
        'API.INVALID_RECIPIENT_EMAIL': 'Ongeldig ontvanger e-mailadres',
        'API.INVALID_RECIPIENT_MOBILE': 'Ongeldig ontvanger mobiel nummer',
        'API.INVALID_RECIPIENT_NAME': 'Ongeldige ontvangernaam',
        'API.INVALID_RECIPIENT_OPENID': 'Ongeldige ontvanger OpenID',
        'API.INVALID_REPLY': 'Ongeldig antwoord',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Ongeldige rapportageperiode eindtijd',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Ongeldige rapportageperiode starttijd',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Ongeldige vereiste authenticatie',
        'API.INVALID_ROOMS_VALUE': 'Ongeldige kamerswaarde',
        'API.INVALID_RULE_ID': 'Ongeldige regel ID',
        'API.INVALID_RULE_NAME': 'Ongeldige regelnaam',
        'API.INVALID_RUN_STATE_POINT_ID': 'Ongeldig bedrijfsstatuspunt ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Ongeldige geplande tijd',
        'API.INVALID_SELL_METER_ID': 'Ongeldig verkoopmeter ID',
        'API.INVALID_SENSOR_ID': 'Ongeldig sensor ID',
        'API.INVALID_SENSOR_NAME': 'Ongeldige sensornaam',
        'API.INVALID_SENSOR_UUID': 'Ongeldige sensor UUID',
        'API.INVALID_SERIAL_NUMBER': 'Ongeldig serienummer',
        'API.INVALID_SERIAL_PORT': 'Ongeldige seriële poort',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Sessie ongeldig, log opnieuw in',
        'API.INVALID_SET_VALUE': 'Ongeldige ingestelde waarde',
        'API.INVALID_SHOPFLOOR_ID': 'Ongeldig werkvloer ID',
        'API.INVALID_SHOPFLOOR_NAME': 'Ongeldige werkvloernaam',
        'API.INVALID_SHOPFLOOR_UUID': 'Ongeldige werkvloer UUID',
        'API.INVALID_SOURCE_NODE_ID': 'Ongeldig bronknooppunt ID',
        'API.INVALID_SPACE_ID': 'Ongeldige ruimte ID',
        'API.INVALID_SPACE_NAME': 'Ongeldige ruimtenaam',
        'API.INVALID_SPACE_UUID': 'Ongeldige ruimte UUID',
        'API.INVALID_START_DATE_FORMAT': 'Ongeldig startdatumformaat',
        'API.INVALID_START_DATETIME': 'Ongeldige starttijd',
        'API.INVALID_STATUS': 'Ongeldige status',
        'API.INVALID_STORE_ID': 'Ongeldig winkel ID',
        'API.INVALID_STORE_NAME': 'Ongeldige winklenaam',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Ongeldige winkelsysteembeschrijving',
        'API.INVALID_STORE_TYPE_ID': 'Ongeldig winkelsysteem ID',
        'API.INVALID_STORE_TYPE_NAME': 'Ongeldige winkelsysteemnaam',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Ongeldige winkelsysteem vereenvoudigde code',
        'API.INVALID_STORE_UUID': 'Ongeldige winkel UUID',
        'API.INVALID_SUBJECT_VALUE': 'Ongeldige onderwerpwaarde',
        'API.INVALID_SVG': 'Ongeldige SVG',
        'API.INVALID_SWITCHGEAR': 'Ongeldige schakelapparatuur',
        'API.INVALID_TARGET_NODE_ID': 'Ongeldig doelknooppunt ID',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Ongeldige bloktarief prijsstelling',
        'API.INVALID_TARIFF_ID': 'Ongeldig tarief ID',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Ongeldige tijd-van-dag tarief prijsstelling',
        'API.INVALID_TARIFF_TYPE': 'Ongeldig tarief type',
        'API.INVALID_TENANT_ID': 'Ongeldig huurder ID',
        'API.INVALID_TENANT_NAME': 'Ongeldige hurdernaam',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Ongeldige huurdersysteembeschrijving',
        'API.INVALID_TENANT_TYPE_ID': 'Ongeldig huurdersysteem ID',
        'API.INVALID_TENANT_TYPE_NAME': 'Ongeldige huurdersysteemnaam',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Ongeldige huurdersysteem vereenvoudigde code',
        'API.INVALID_TENANT_UUID': 'Ongeldige huurder UUID',
        'API.INVALID_TEXT_MESSAGE_ID': 'Ongeldig SMS ID',
        'API.INVALID_TIMEZONE_ID': 'Ongeldige tijdzone ID',
        'API.INVALID_TOKEN': 'Ongeldig token',
        'API.INVALID_TOPIC': 'Ongeldig onderwerp',
        'API.INVALID_UNIT_OF_MEASURE': 'Ongeldige meeteenheid',
        'API.INVALID_UNIT_OF_PRICE': 'Ongeldige prijseenheid',
        'API.INVALID_UNITS': 'Ongeldige eenheden',
        'API.INVALID_USER_ID': 'Ongeldig gebruiker ID',
        'API.INVALID_USER_NAME': 'Ongeldige gebruikersnaam',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Ongeldige gebruikersnaam of e-mailadres',
        'API.INVALID_USER_PHONE': 'Ongeldig gebruikers telefoonnummer',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Ongeldige gebruiker log opnieuw in',
        'API.INVALID_USER_UUID': 'Ongeldige gebruiker UUID',
        'API.INVALID_USERNAME': 'Ongeldige gebruikersnaam',
        'API.INVALID_VARIABLE_METER_ID': 'Ongeldig variabele meter ID',
        'API.INVALID_VARIABLE_METER_TYPE': 'Ongeldig variabele meter type',
        'API.INVALID_VARIABLE_NAME': 'Ongeldige variabelenaam',
        'API.INVALID_VERIFICATION_CODE': 'Ongeldige verificatiecode',
        'API.INVALID_VIRTUAL_METER_ID': 'Ongeldig virtuele meter ID',
        'API.INVALID_VIRTUAL_METER_NAME': 'Ongeldige virtuele meternaam',
        'API.INVALID_VIRTUAL_METER_UUID': 'Ongeldige virtuele meter UUID',
        'API.INVALID_WEB_MESSAGE_ID': 'Ongeldig webbericht ID',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Ongeldig WeChat bericht ID',
        'API.INVALID_WIND_FARM_ID': 'Ongeldig windpark ID',
        'API.INVALID_WIND_FARM_NAME': 'Ongeldige windpark naam',
        'API.INVALID_WORKING_CALENDAR_ID': 'Ongeldig werkagenda ID',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Ongeldige werkagendanaam',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Kan kennisbestand niet van schijf verwijderen',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Kennisbestand bestaat niet',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'Hoofdmeter behoort niet tot dezelfde energiecategorie',
        'API.MASTER_METER_NOT_FOUND': 'Hoofdmeter bestaat niet',
        'API.MENU_NOT_FOUND': 'Menu bestaat niet',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter kan niet meer dan één energie waardepunt hebben',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter opdrachtsrelatie bestaat',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter opdrachtsrelatie niet gevonden',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Meetmeternaam is al in gebruik',
        'API.METER_NOT_FOUND': 'Meetmeter bestaat niet',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Variabele meetmeter bestaat niet',
        'API.METER_POINT_RELATION_EXISTS': 'Relatie meetmeter en datapunt bestaat al',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Relatie meetmeter en datapunt bestaat niet',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid batterij naam is al in gebruik',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid batterij niet gevonden',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid EV-laadpaal naam is al in gebruik',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid EV-laadpaal niet gevonden',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator naam is al in gebruik',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator niet gevonden',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid net naam is al in gebruik',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid net niet gevonden',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid warmtepomp naam is al in gebruik',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid warmtepomp niet gevonden',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid belasting naam is al in gebruik',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid belasting niet gevonden',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid naam is al in gebruik',
        'API.MICROGRID_NOT_FOUND': 'Microgrid niet gevonden',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid fotovoltaïsch naam is al in gebruik',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid fotovoltaïsch niet gevonden',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid vermogensomzettingssysteem naam is al in gebruik',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid vermogensomzettingssysteem niet gevonden',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensorrelatie bestaat',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor niet gevonden',
        'API.MQTT_CONNECTION_ERROR': 'MQTT verbindingsfout',
        'API.MQTT_PUBLISH_ERROR': 'MQTT publicatiefout',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Nieuw wachtwoord lengte mag niet meer dan 100 tekens zijn',
        'API.NEW_USER_SESSION_NOT_FOUND': 'Nieuwe gebruikerssessie niet gevonden',
        'API.NEW_USER_SESSION_TIMEOUT': 'Nieuwe gebruikerssessie verlopen',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Niet-werkdag bestaat niet',
        'API.NOT_FOUND': 'Bestaat niet',
        'API.NOTIFICATION_NOT_FOUND': 'Notificatie bestaat niet',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meterbestand bestaat niet',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meternaam is al in gebruik',
        'API.OFFLINE_METER_NOT_FOUND': 'Offline meter bestaat niet',
        'API.INVALID_OFFLINE_METER_VALUE': 'Ongeldige offline meterwaarde',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter variabele bestaat niet',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Oud wachtwoord lengte mag niet meer dan 100 tekens zijn',
        'API.PARENT_SPACE_NOT_FOUND': 'Bovenliggende ruimte bestaat niet',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Wachtwoord lengte mag niet meer dan 100 tekens zijn',
        'API.PASSWORDS_MATCH': 'Nieuw wachtwoord komt overeen met oud wachtwoord',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Fotovoltaïsche centrale naam is al in gebruik',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Fotovoltaïsche centrale niet gevonden',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Datapuntnaam is al in gebruik',
        'API.POINT_NOT_FOUND': 'Datapunt bestaat niet',
        'API.POWER_POINT_NOT_FOUND': 'Vermogenspunt niet gevonden',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilegenaam is al in gebruik',
        'API.PRIVILEGE_NOT_FOUND': 'Privilege bestaat niet',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Regelnaam is al in gebruik',
        'API.RULE_NOT_FOUND': 'Regel bestaat niet',
        'API.SELL_METER_NOT_FOUND': 'Verkoopmeter niet gevonden',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensornaam is al in gebruik',
        'API.SENSOR_NOT_FOUND': 'Sensor bestaat niet',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Relatie sensor en datapunt bestaat al',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Relatie sensor en datapunt bestaat niet',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Werkvloer opdrachtsrelatie bestaat',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Werkvloer opdrachtsrelatie niet gevonden',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Relatie werkvloer en apparaat bestaat al',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Relatie werkvloer en apparaat bestaat niet',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Relatie werkvloer en meetmeter bestaat al',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Relatie werkvloer en meetmeter bestaat niet',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Werkvloernaam is al in gebruik',
        'API.SHOPFLOOR_NOT_FOUND': 'Werkvloer bestaat niet',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Relatie werkvloer en offline meter bestaat al',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie werkvloer en offline meter bestaat niet',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Relatie werkvloer en datapunt bestaat al',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Relatie werkvloer en datapunt bestaat niet',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Relatie werkvloer en sensor bestaat al',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Relatie werkvloer en sensor bestaat niet',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Relatie werkvloer en virtuele meter bestaat al',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie werkvloer en virtuele meter bestaat niet',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Werkvloer werkagenda relatie bestaat al',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Werkvloer en werkagenda relatie bestaat niet',
        'API.SOC_POINT_NOT_FOUND': 'SOC punt niet gevonden',
        'API.SOURCE_NODE_NOT_FOUND': 'Bronknooppunt bestaat niet',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Relatie ruimte en gecombineerde apparatuur bestaat al',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Relatie ruimte en gecombineerde apparatuur bestaat niet',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Ruimte opdrachtsrelatie bestaat',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Ruimte opdrachtsrelatie niet gevonden',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Ruimte Energieopslagcentrale Relatie Bestaat',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Ruimte Energieopslagcentrale Relatie Niet Gevonden',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Relatie ruimte en apparaat bestaat al',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Relatie ruimte en apparaat bestaat niet',
        'API.SPACE_METER_RELATION_EXISTS': 'Relatie ruimte en meetmeter bestaat al',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Relatie ruimte en meetmeter bestaat niet',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Ruimtenaam is al in gebruik',
        'API.SPACE_NOT_FOUND': 'Ruimte bestaat niet',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Ruimte bestaat niet in privilege',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Relatie ruimte en offline meter bestaat al',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie ruimte en offline meter bestaat niet',
        'API.SPACE_POINT_RELATION_EXISTS': 'Relatie ruimte en datapunt bestaat al',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Relatie ruimte en datapunt bestaat niet',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Relatie ruimte en sensor bestaat al',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Relatie ruimte en sensor bestaat niet',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Relatie ruimte en werkvloer bestaat al',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Relatie ruimte en werkvloer bestaat niet',
        'API.SPACE_STORE_RELATION_EXISTS': 'Relatie ruimte en winkel bestaat al',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Relatie ruimte en winkel bestaat niet',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Relatie ruimte en huurder bestaat al',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Relatie ruimte en huurder bestaat niet',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Relatie ruimte en virtuele meter bestaat al',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie ruimte en virtuele meter bestaat niet',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Relatie ruimte en werkagenda bestaat al',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relatie ruimte en werkagenda bestaat niet',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Starttijd moet eerder zijn dan eindtijd',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Winkel opdrachtsrelatie bestaat',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Winkel opdrachtsrelatie niet gevonden',
        'API.STORE_METER_RELATION_EXISTS': 'Relatie winkel en meetmeter bestaat al',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Relatie winkel en meetmeter bestaat niet',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Winkelnaam is al in gebruik',
        'API.STORE_NOT_FOUND': 'Winkel bestaat niet',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Relatie winkel en offline meter bestaat al',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie winkel en offline meter bestaat niet',
        'API.STORE_POINT_RELATION_EXISTS': 'Relatie winkel en datapunt bestaat al',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Relatie winkel en datapunt bestaat niet',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Relatie winkel en sensor bestaat al',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Winkel sensor relatie bestaat niet',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Winkelsysteemnaam is al in gebruik',
        'API.STORE_TYPE_NOT_FOUND': 'Winkelsysteem bestaat niet',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Winkelsysteem vereenvoudigde code is al in gebruik',
        'API.STORE_TYPE_USED_IN_STORE': 'Winkelsysteem wordt al gebruikt in winkel',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Relatie winkel en virtuele meter bestaat al',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie winkel en virtuele meter bestaat niet',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Winkel en werkagenda relatie bestaat al',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Winkel en werkagenda relatie bestaat niet',
        'API.TARGET_NODE_NOT_FOUND': 'Doelknooppunt bestaat niet',
        'API.TARIFF_IN_USE': 'Tarief wordt gebruikt',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tarief en kostenplaats zijn al geassocieerd',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tarief en kostenplaats zijn niet geassocieerd',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariefnaam is al in gebruik',
        'API.TARIFF_NOT_FOUND': 'Tarief bestaat niet',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Huurder opdrachtsrelatie bestaat',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Huurder opdrachtsrelatie niet gevonden',
        'API.TENANT_METER_RELATION_EXISTS': 'Relatie huurder en meetmeter bestaat al',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Relatie huurder en meetmeter bestaat niet',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Huurdernaam is al in gebruik',
        'API.TENANT_NOT_FOUND': 'Huurder bestaat niet',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Relatie huurder en offline meter bestaat al',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relatie huurder en offline meter bestaat niet',
        'API.TENANT_POINT_RELATION_EXISTS': 'Relatie huurder en datapunt bestaat al',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Relatie huurder en datapunt bestaat niet',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Relatie huurder en sensor bestaat al',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Huurder en sensor relatie bestaat niet',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Huurder en systeemnaam is al in gebruik',
        'API.TENANT_TYPE_NOT_FOUND': 'Huurdersysteem bestaat niet',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Huurdersysteem vereenvoudigde code is al in gebruik',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Huurdersysteem wordt al gebruikt in huurder',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Relatie huurder en virtuele meter bestaat al',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relatie huurder en virtuele meter bestaat niet',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Huurder en werkagenda relatie bestaat al',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Huurder en werkagenda relatie bestaat niet',
        'API.TEXT_MESSAGE_NOT_FOUND': 'SMS niet gevonden',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'Rapportageperiode moet langer zijn dan 15 minuten',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Relatie met submeters',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Relatie met onderliggende ruimtes',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'Relatie met gecombineerde apparaat parameters',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Relatie met gecombineerde apparatuur',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Relatie met gegevensbronnen',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'Relatie met energieflowdiagram',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'Relatie met energieopslagcontainer batterijen',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'Relatie met energieopslagcontainer netten',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'Relatie met energieopslagcontainer belastingen',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'Relatie met energieopslagcontainer vermogensomzettingssystemen (PCS)',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Relatie met apparaat parameters',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Relatie met apparatuur',
        'API.THERE_IS_RELATION_WITH_METER': 'Relatie met meetmeter',
        'API.THERE_IS_RELATION_WITH_METERS': 'Relatie met meerdere meetmeters',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Relatie met offline meter',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Relatie met meerdere offline meters',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Relatie met virtuele meter',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'Relatie met sensoren',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Relatie met werkvloeren',
        'API.THERE_IS_RELATION_WITH_SPACES': 'Relatie met ruimtes',
        'API.THERE_IS_RELATION_WITH_STORES': 'Relatie met winkels',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'Relatie met huurders',
        'API.THERE_IS_RELATION_WITH_USERS': 'Relatie met gebruikers',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Relatie met virtuele meter',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Relatie met virtuele energiecentrales',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'Deze gegevensbron wordt gebruikt door een meetmeter',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Deze meetmeter wordt gebruikt door een virtuele meter',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Deze offline meter wordt gebruikt door een virtuele meter',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'Ruimte kan niet gekloond worden',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'Ruimte kan niet verwijderd worden',
        'API.TIMEZONE_NOT_FOUND': 'Tijdzone bestaat niet',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token niet gevonden, log in',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'Gebruikersaccount is geblokkeerd',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'Gebruikersaccount is verlopen',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'Gebruikersaccount is niet geblokkeerd',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'Gebruikersnaam is al in gebruik',
        'API.USER_NOT_FOUND': 'Gebruiker bestaat niet',
        'API.USER_PASSWORD_HAS_EXPIRED': 'Gebruikerswachtwoord is verlopen',
        'API.USER_PRIVILEGE_NOT_FOUND': 'Gebruikersprivilege niet gevonden',
        'API.USER_SESSION_NOT_FOUND': 'Gebruikerssessie niet gevonden',
        'API.USER_SESSION_TIMEOUT': 'Gebruikerssessie verlopen',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Gebruikers UUID bestaat niet, log in',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtuele meternaam is al in gebruik',
        'API.VIRTUAL_METER_NOT_FOUND': 'Virtuele meter bestaat niet',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Variabele virtuele meter bestaat niet',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtueel datapunt moet analoog zijn',
        'API.WEB_MESSAGE_NOT_FOUND': 'Webbericht bestaat niet',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'WeChat bericht bestaat niet',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Windpark naam is al in gebruik',
        'API.WIND_FARM_NOT_FOUND': 'Windpark niet gevonden',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Werkagendanaam is al in gebruik',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Werkagenda bestaat niet',

        MasterMeter: 'Hoofdmeter',
        SubMeter: 'Submeter',
        'Power Quality': 'Kwaliteit van stroomvoorziening',
        'About Power Quality': 'Over Kwaliteit van Stroomvoorziening',
        Category: 'Categorie',
        Type: 'Type',
        Limit: 'Limiet',
        'Normal Limit': 'Normale limiet',
        'Severe Limit': 'Ernstige limiet',
        Compliance: 'Compliance percentage',
        'Worst Deviation': 'Slechtste afwijking',
        'Worst Time': 'Slechtste tijdstip',
        'Severe Exceed Count': 'Aantal ernstige overschrijdingen',
        'Worst Unbalance': 'Maximale onbalans',
        Hz: 'Hertz',
        voltage: 'Spanning',
        current: 'Stroom',
        frequency: 'Frequentie',
        voltage_deviation: 'Spanningsafwijking',
        current_unbalance: 'Stroomonbalans',
        voltage_unbalance: 'Spanningsonbalans',
        mean_deviation_pct: 'Gemiddelde afwijking (%)',
        p95_abs_deviation_pct: 'P95 absolute afwijking (%)',
        mean_abs_deviation_hz: 'Gemiddelde absolute afwijking (Hz)',
        frequency_deviation: 'Frequentieafwijking',
        p95_abs_deviation_hz: 'P95 absolute afwijking (Hz)',
        mean_unbalance_pct: 'Gemiddelde onbalans (%)',
        p95_unbalance_pct: 'P95 onbalans (%)',
        count: 'Aantal',
        min: 'Minimum',
        max: 'Maximum',
        mean: 'Gemiddelde',
        std: 'Standaardafwijking',
        p5: 'P5',
        p95: 'P95'
    }
};
